import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatSnackBar } from "@angular/material";
import { environment } from '../../environments/environment';

import { ServicioService } from '../services/servicio.service';
import { Servicio } from '../models/servicio';
import { ServicioEditorComponent } from '../servicio-editor/servicio-editor.component';
import { ServicioImgExtraEditorComponent } from '../servicio-img-extra-editor/servicio-img-extra-editor.component';

import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-servicio-list',
  templateUrl: './servicio-list.component.html',
  styleUrls: ['./servicio-list.component.css']
})
export class ServicioListComponent implements OnInit {


  models: Servicio[];
  Url = environment.imgUrl;

  constructor(private modelService: ServicioService, public dialog: MatDialog, private snackBar: MatSnackBar) {
    this.models = [];
  }

  ngOnInit() {
    this.getAll();
  }

  openEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(ServicioEditorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        this.getAll();
        if (data != undefined && data != 0) this.openServicioImgExtraEditor(data);
      }
    );
  }
  openServicioImgExtraEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(ServicioImgExtraEditorComponent, dialogConfig);
  }
  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.delete(id).subscribe(
            val => {
              this.getAll();
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  getAll() {

    this.modelService.getAll().subscribe(val => {
      this.models = val;

    },
      error => {
        console.log(error);
        console.log(<any>error);
      });

  }
}
